import { Component, inject, OnInit } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { ConfigurationService } from '../../core/services/configs/configuration';
import { environment } from '../../../environments/environment';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { AllStatus } from '../../core/services/status/all-status';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-footer',
  imports: [TranslatePipe, CommonModule, MatButtonModule, MatIconModule],
  templateUrl: './footer.html',
  styleUrl: './footer.scss'
})
export class Footer implements OnInit {
  configuration = inject(ConfigurationService);
  allStatus = inject(AllStatus);
  subscription: Subscription;
  isfotter: boolean = true;
  referalName: string = '';
  linkDemo: string = "";
  linkNotreferal: string = "";

  isOpen = false;

  public settings = environment;

  ngOnInit() {
    this.settings.isProduction == 'production' ? this.isfotter = false : this.isfotter = true;
    this.linkDemo = this.settings.linkLending;
    this.linkNotreferal = `${this.settings.linkLending}?refid=1005`;
    this.subscription = this.allStatus.openFooter.subscribe((value: boolean) => {
      if(value){
        this.isOpen = true;
      }else{
        this.isOpen = false;
      }
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  closeReferal(){
    this.isfotter = !this.isfotter
  }

  toggleMenu() {
    this.isOpen = !this.isOpen;
  }

}
